import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-responsive-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css';

function ActivityLogs() {
  const initialLogs = useMemo(
    () => [
      { id: 'LOG-5001', timestamp: '2025-02-10 10:15:23', user: 'admin@owena.com', action: 'LOGIN', resource: 'Auth', ip: '192.168.1.10', status: 'Success', details: 'Successful login' },
      { id: 'LOG-5002', timestamp: '2025-02-10 10:20:05', user: 'ava.smith@example.com', action: 'UPDATE', resource: 'Order ORD-1003', ip: '192.168.1.23', status: 'Success', details: 'Marked as Shipped' },
      { id: 'LOG-5003', timestamp: '2025-02-10 10:30:44', user: 'system', action: 'CRON', resource: 'Reports', ip: '-', status: 'Success', details: 'Daily metrics generated' },
      { id: 'LOG-5004', timestamp: '2025-02-10 11:01:09', user: 'johnee.bolbi@example.com', action: 'DELETE', resource: 'Product PRD-1003', ip: '192.168.1.45', status: 'Denied', details: 'Insufficient permissions' },
    ],
    []
  );

  const [logs, setLogs] = useState(initialLogs);
  const [selectedLog, setSelectedLog] = useState(null);
  const tableRef = useRef(null);

  useEffect(() => {
    if (!tableRef.current) return;
    const $table = $(tableRef.current);
    if ($.fn.dataTable.isDataTable($table)) $table.DataTable().destroy();
    $table.DataTable({
      responsive: true,
      pageLength: 10,
      lengthMenu: [5, 10, 25, 50, 100],
      autoWidth: false,
      order: [[0, 'desc']],
      columnDefs: [
        { orderable: false, targets: [6] },
      ],
    });
    return () => { if ($.fn.dataTable.isDataTable($table)) $table.DataTable().destroy(); };
  }, [logs]);

  function openDetails(log) {
    setSelectedLog(log);
    try {
      const el = document.getElementById('logDetailModal');
      if (el && window.bootstrap) (window.bootstrap.Modal.getInstance(el) || new window.bootstrap.Modal(el)).show();
    } catch {}
  }

  function clearLogs() {
    setLogs([]);
  }

  return (
    <>
      <Helmet><title>Activity Logs | Owena Admin Dashboard</title></Helmet>
      <div className="ec-content-wrapper">
        <div className="content">
          <div className="breadcrumb-wrapper breadcrumb-contacts">
            <div>
              <h1>Activity Logs</h1>
              <p className="breadcrumbs"><span><a href="#" onClick={(e)=>e.preventDefault()}>Home</a></span><span><i className="mdi mdi-chevron-right"></i></span>Settings</p>
            </div>
            <div>
              <button className="btn btn-outline-danger" onClick={clearLogs}>Clear All</button>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="ec-vendor-list card card-default">
                <div className="card-body">
                  <div className="table-responsive">
                    <table id="activity-logs-table" ref={tableRef} className="table">
                      <thead>
                        <tr>
                          <th>Timestamp</th>
                          <th>User</th>
                          <th>Action</th>
                          <th>Resource</th>
                          <th>IP</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {logs.map(l => (
                          <tr key={l.id}>
                            <td>{l.timestamp}</td>
                            <td>{l.user}</td>
                            <td>{l.action}</td>
                            <td>{l.resource}</td>
                            <td>{l.ip}</td>
                            <td><span className={`ec-status ${l.status === 'Success' ? 'ec-active' : l.status === 'Denied' ? 'ec-inactive' : 'ec-pending'}`}>{l.status}</span></td>
                            <td>
                              <button className="btn btn-outline-success" onClick={() => openDetails(l)}>Details</button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Log Detail Modal */}
          <div className="modal fade" id="logDetailModal" tabIndex="-1" aria-labelledby="logDetailModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-centered"><div className="modal-content">
              <div className="modal-header px-4"><h5 className="modal-title" id="logDetailModalLabel">Log Details</h5><button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div>
              <div className="modal-body px-4">
                {selectedLog ? (
                  <div>
                    <div className="row mb-3"><div className="col-md-6"><strong>Timestamp:</strong> {selectedLog.timestamp}</div><div className="col-md-6"><strong>User:</strong> {selectedLog.user}</div></div>
                    <div className="row mb-3"><div className="col-md-6"><strong>Action:</strong> {selectedLog.action}</div><div className="col-md-6"><strong>Status:</strong> {selectedLog.status}</div></div>
                    <div className="row mb-3"><div className="col-md-12"><strong>Resource:</strong> {selectedLog.resource}</div></div>
                    <div className="row mb-3"><div className="col-md-12"><strong>IP:</strong> {selectedLog.ip}</div></div>
                    <div className="row mb-3"><div className="col-md-12"><strong>Details:</strong> {selectedLog.details}</div></div>
                  </div>
                ) : <p>No log selected.</p>}
              </div>
            </div></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ActivityLogs;
